import * as React from 'react';
import { useStyles } from '../styles';
import { AttendantUserInfo } from '@/components';
import { inIframe } from '@/utils';
import { Link } from 'react-router-dom';
import { HomeNavButtons } from '@/pages/Home/HomeNavButtons';
import { DashboardButton } from '@/pages/Home/DashboardButton';
import { useAttendantData } from '@/zustand/useAttendantData';

export const AttendantFlow = () => {
  const isInIframe = inIframe();
  const styles = useStyles({ isInIframe });
  const { user, token } = useAttendantData((store) => store);
  const isAttendantAuthenticated = !!user && !!token;

  return (
    <>
      {isAttendantAuthenticated ? (
        <>
          <DashboardButton />
          <AttendantUserInfo />
          <HomeNavButtons />
        </>
      ) : (
        <Link className={styles.link} to={'/enter-attendant-id'}>
          Tap to begin
        </Link>
      )}
    </>
  );
};
